































import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import PopupCloseButton from '@/components/popups/PopupCloseButton.vue';
import CalendarDay from '@/components/popups/CalendarDay.vue';
import CalendarMonthPicker from '@/components/popups/CalendarMonthPicker.vue';
import Popup from '@/components/popups/Popup.vue';
import { getCalendarEntries } from '@/utils/calendar-dates';
import { dateToYYYYMMDD, getAbbreviatedDayName } from '@/utils/date-helpers';
import { playSound } from '@/utils/playSound';

const puzzle = namespace('Puzzle');

const ui = namespace('UI');

@Component({
  components: {
    CalendarDay,
    Popup,
    CalendarMonthPicker,
    PopupCloseButton,
  },
})
export default class Calendar extends Vue {
  @puzzle.Action
  public handleTempDate!: (date: Date) => void;

  @ui.Mutation
  private closePopup!: () => void;

  private calendarDate: number = Date.now();

  get date() {
    return new Date(this.calendarDate);
  }

  private getDateText(value: number) {
    return getAbbreviatedDayName(value);
  }

  get dayEntries() {
    return getCalendarEntries(this.date.getFullYear(), this.date.getMonth());
  }

  public handleMonthIndexChange(change: number): void {
    playSound('buttonClickSound');
    const newTimeStamp = new Date(this.calendarDate).setMonth(this.date.getMonth() + change);

    if (newTimeStamp < Date.now()) {
      this.calendarDate = newTimeStamp;
    }
  }
}
